const PANEL_SCOPE_STORAGE_KEY = 'waitercall.panelScope';

const normalizeName = (value) => {
  const normalized = typeof value === 'string' ? value.trim() : '';
  return normalized.length ? normalized : '';
};

export const readPanelScope = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(PANEL_SCOPE_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    const companyId = typeof parsed?.companyId === 'string' ? parsed.companyId.trim() : '';
    const restaurantId = typeof parsed?.restaurantId === 'string' ? parsed.restaurantId.trim() : '';

    if (!companyId || !restaurantId) {
      return null;
    }

    return {
      companyId,
      companyName: normalizeName(parsed?.companyName),
      restaurantId,
      restaurantName: normalizeName(parsed?.restaurantName),
    };
  } catch {
    return null;
  }
};

export const writePanelScope = ({
  companyId,
  companyName = '',
  restaurantId,
  restaurantName = '',
}) => {
  if (typeof window === 'undefined') {
    return;
  }

  const normalizedCompanyId = typeof companyId === 'string' ? companyId.trim() : '';
  const normalizedRestaurantId = typeof restaurantId === 'string' ? restaurantId.trim() : '';
  if (!normalizedCompanyId || !normalizedRestaurantId) {
    return;
  }

  try {
    window.localStorage.setItem(
      PANEL_SCOPE_STORAGE_KEY,
      JSON.stringify({
        companyId: normalizedCompanyId,
        companyName: normalizeName(companyName),
        restaurantId: normalizedRestaurantId,
        restaurantName: normalizeName(restaurantName),
      }),
    );
  } catch {
    // Panel scope persistence is best-effort and must not block navigation.
  }
};

export const clearPanelScope = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(PANEL_SCOPE_STORAGE_KEY);
  } catch {
    // Panel scope cleanup is best-effort and must not block logout.
  }
};
